import { render, staticRenderFns } from "./details-reisetermine-overview.vue?vue&type=template&id=2170bfb7"
import script from "./details-reisetermine-overview.vue?vue&type=script&lang=js"
export * from "./details-reisetermine-overview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports